/* eslint-disable @typescript-eslint/no-explicit-any */
import { Bnsl129NoticePopup } from "@/components/Bnsl129NoticePopup"
import { Crpc129NoticePopup } from "@/components/Crpc129NoticePopup"
import { CrpcBondOrderPopup } from "@/components/CrpcBondOrderPopup"
import { FileUpload } from "@/components/file-upload"
import { GDFormPopup } from "@/components/gd-form-popup"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
// import { d107_new } from "@/data/sampleDoc"
import { 
  // useEffect,
  useState 
} from "react"

function UploadDocument() {
  const [showGDForm, setShowGDForm] = useState(false)
  const [showCrpc129Notice, setShowCrpc129Notice] = useState(false)
  const [showBNSL129Notice, setShowBNSL129Notice] = useState(false)
  const [showCrpcBondOrder, setShowCrpcBondOrder] = useState(false)
  const [extractedData, setExtractedData] = useState<any>(null)

  const handleFileProcessed = (data: any) => {
    setExtractedData(data)
    if(data.documentType == '107'){
      setShowGDForm(true)
    }else if(data.documentType == '111'){
      setShowCrpc129Notice(true)
    }else if(data.documentType == '116' || data.documentType == '116_3'){
      setShowBNSL129Notice(true)
    }else if(data.documentType == '117'){
      setShowCrpcBondOrder(true)
    }else{
      setShowGDForm(true)
    }
  }
  // useEffect(() => {
  //   handleFileProcessed(d107_new)
  // },[])
  return (
    <>
      <GDFormPopup open={showGDForm} onOpenChange={setShowGDForm} data={extractedData} />
      <Crpc129NoticePopup open={showCrpc129Notice} onOpenChange={setShowCrpc129Notice} data={extractedData} />
      <Bnsl129NoticePopup open={showBNSL129Notice} onOpenChange={setShowBNSL129Notice} data={extractedData} />
      <CrpcBondOrderPopup open={showCrpcBondOrder} onOpenChange={setShowCrpcBondOrder} data={extractedData} />
      <Card className="border border-gray-200 m-10">
        <CardHeader>
          <CardTitle className="text-black">Upload Documents</CardTitle>
          <CardDescription className="text-gray-600">
            Upload police documents for OCR processing and form generation
          </CardDescription>
        </CardHeader>
        <CardContent>
          <FileUpload onFileProcessed={handleFileProcessed} />
        </CardContent>
      </Card>
    </>
    
  )
}

export default UploadDocument